import { render, staticRenderFns } from "./Costs.vue?vue&type=template&id=2218fa99&scoped=true"
import script from "./Costs.vue?vue&type=script&setup=true&lang=ts"
export * from "./Costs.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Costs.vue?vue&type=style&index=0&id=2218fa99&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2218fa99",
  null
  
)

export default component.exports